import { PaymentMethods } from '@betterplace/api-graphql-types/enums'

import { useDonationFormValues } from '@/donationPages/_dependencies/helpers'
import { useEffect } from 'react'

import useNativePaymentMethodsAreAvailable from '../useNativePaymentMethodsAreAvailable'
import usePaymentMethodsToRender from '../usePaymentMethodsToRender'
import { useFormContext } from 'react-hook-form'

const DEFAULT_PAYMENT_METHOD_PRIORITY = [
  PaymentMethods.Paypal,
  PaymentMethods.StripeApplePay,
  PaymentMethods.StripeGooglePay,
  PaymentMethods.StripeSepaDebit,
]

function useSelectDefaultPaymentMethod() {
  const { paymentMethodsToRender, nativePaymentsLoading } = usePaymentMethodsToRender()
  const shouldUseNativePaymentMethods = useNativePaymentMethodsAreAvailable()
  const { setValue } = useFormContext()
  const [selectedPaymentMethod] = useDonationFormValues(['payment_method'])

  useEffect(() => {
    if (nativePaymentsLoading) return
    if (paymentMethodsToRender.includes(selectedPaymentMethod)) return

    const preferred =
      DEFAULT_PAYMENT_METHOD_PRIORITY.find((value) => paymentMethodsToRender.includes(value)) || selectedPaymentMethod

    if (selectedPaymentMethod === preferred) return

    setValue('_default_payment_method', preferred)
    setValue('payment_method', preferred)
  }, [paymentMethodsToRender, selectedPaymentMethod, setValue, nativePaymentsLoading, shouldUseNativePaymentMethods])
}

export default useSelectDefaultPaymentMethod
